export const ROUTE_NAMES = {
	COMPLIANCE_ADDRESS: "compliance-address",
	COMPLIANCE_COMPLETE: "compliance-complete",
	COMPLIANCE_CONCERN: "compliance-concern",
	COMPLIANCE_CONTACT: "compliance-contact",
	COMPLIANCE_EVIDENCE: "compliance-evidence",
	COMPLIANCE_INTRO: "compliance-intro",
	COMPLIANCE_PERMISSION: "compliance-permission",
	COMPLIANCE_PROCESS: "compliance-process",
	COMPLIANCE_SUBMIT: "compliance-submit",
	MOSQUITO_CHECK_WELCOME: "mosquito-check-welcome",
	MOSQUITO_CHECK_WALK: "mosquito-check-walk",
	MOSQUITO_CHECK_BEYOND: "mosquito-check-beyond",
	MOSQUITO_CHECK_CONTACT: "mosquito-check-contact",
	MOSQUITO_CHECK_COMPLETE: "mosquito-check-complete",
	REGISTER_NOTIFICATIONS_COMPLETE: "register-notifications-complete",
	REVIEW_SITE: "review-site",
	STATUS_BY_ID: "status-by-id",
} as const;

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];
